const AMOUNT_PRESETS_MINOR: number[] = [10000, 20000, 50000, 100000];

export type DonationJourneyStep = 'amount' | 'project' | 'method' | 'pay';

export type DonationPaymentMethod = 'qr' | 'gateway';

export function formatMinorAmount(amountMinor: number, currency: string, locale: string): string {
  const safeCurrency =
    typeof currency === 'string' && currency.trim().length >= 3
      ? currency.trim().toUpperCase()
      : 'CZK';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: safeCurrency,
    maximumFractionDigits: 2,
  }).format(amountMinor / 100);
}

export function readErrorCode(err: unknown): string | undefined {
  if (err && typeof err === 'object' && 'code' in err) {
    const code = (err as { code?: unknown }).code;
    if (typeof code === 'string') {
      return code;
    }
  }
  return undefined;
}

export function resolveInitialDonationStep(
  hasLegacyCode: boolean,
  startsOnProjectPicker: boolean,
): DonationJourneyStep {
  if (hasLegacyCode) {
    return 'amount';
  }
  if (startsOnProjectPicker) {
    return 'project';
  }
  return 'amount';
}

export function resolveVisibleDonationStep(
  step: DonationJourneyStep,
  hasLegacyCode: boolean,
  pathname: string,
  projectsPath: string,
  donatePath: string,
): DonationJourneyStep {
  if (step === 'method' || step === 'pay') {
    return step;
  }
  if (hasLegacyCode) {
    return step;
  }
  if (pathname === projectsPath) {
    return 'project';
  }
  if (pathname === donatePath) {
    return 'amount';
  }
  return step;
}

export function buildAmountPresets(defaultAmountMinor: number | null | undefined): number[] {
  const baseline = [...AMOUNT_PRESETS_MINOR];
  if (typeof defaultAmountMinor === 'number' && defaultAmountMinor > 0 && !baseline.includes(defaultAmountMinor)) {
    baseline.push(defaultAmountMinor);
  }
  return Array.from(new Set(baseline)).sort((a, b) => a - b);
}
